const STORAGE_KEY = 'bt.member.token';
/** The division a multi-division member last chose (FR-222: remembered per device). */
const DIVISION_KEY = 'bt.member.divisionId';

/**
 * v0.15 (ADR-0008): the member's own session token, kept exactly the way the
 * kiosk keeps its device token — same storage, same lifecycle — but bound to
 * a person and valid 60 days (D-3).
 *
 * PRD R-2 is the thing to remember here: iOS may evict a rarely-used web
 * app's storage, and a Monatsevent means ~4 weeks between uses. Every read
 * must therefore treat "gone" as an ordinary state, never an error, and the
 * app has to fall back to the code screen gracefully (FR-221).
 */
export function getMemberToken(): string | undefined {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? undefined;
  } catch {
    // Storage disabled entirely (private mode, browser setting). Not being
    // recognised is recoverable -- the member simply retypes their code -- so
    // this must not throw its way onto the screen.
    return undefined;
  }
}

export function setMemberToken(token: string): void {
  localStorage.setItem(STORAGE_KEY, token);
}

export function clearMemberToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(DIVISION_KEY);
  } catch {
    // Nothing to do: without storage there is nothing to clear.
  }
}

export function getRememberedDivisionId(): string | undefined {
  try {
    return localStorage.getItem(DIVISION_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function rememberDivisionId(divisionId: string): void {
  try {
    localStorage.setItem(DIVISION_KEY, divisionId);
  } catch {
    // A member who cannot store this simply picks their division each time.
  }
}
